<template>
  <div style="margin-top:-30px;">
    <h4>{{ msg('选择字段') }}</h4>
    <div class="search-wrap">
      <el-input placeholder="请输入内容" v-model="leftInput"
                @input="leftSearchInput" @clear="leftClearSearch"
                prefix-icon="el-icon-search" size="mini" class="left-search"
      ></el-input>
    </div>
    <el-scrollbar class="vlist" style="height:350px;" ref="fieldList">
      <template>
        <span v-for="table in tables" :key="table.tableName+'.'+table.alias">
            <h4 class="group-name">{{ table.tableLable }}</h4>
            <template v-for="item in table.columns">
                <a v-show="!item.selected" :key="item.colName"
                   :class="['col-item', {'active': item.active}]"
                   @click="leftItemClick(item)"
                >{{ item.label }}</a>
            </template>
        </span>
      </template>
    </el-scrollbar>
    <div style="text-align: center">
      <el-button size="small" @click="onSubmit">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockFieldSelect',
  data() {
    return {
      leftInput: null,
      searching: false,
      tables: [],
    }
  },
  mounted: function () {
    this.initList();
  },
  methods: {
    initList() {
      var _this = this;
      this.$axios.get(this.$kit.api.viewSetting.tables + "?t=1")
          .then((result) => {
            if (result.status) {
              _this.tables = result.data.columns;
            }
          });
    },
    //左边单击, 选中点击项
    leftItemClick(item) {
      item.active = !item.active;
      this.$forceUpdate()
    },
    //显示字段，左边搜索
    leftSearchInput(val) {
      if (this.searching) {
        return;
      }
      this.searching = true;
      this.tables.forEach(t => {
        t.columns.forEach(c => {
          if (c.label.indexOf(val) == -1) {
            c.selected = true;
          } else {
            c.selected = false;
          }
        });
      });
      this.searching = false;
    },
    //显示字段，清除左边的搜索条件
    leftClearSearch() {
      this.tables.forEach(t => {
        t.columns.forEach(c => {
          c.selected = false;
        });
      });
    },
    onSubmit() {
      var list = [];
      this.tables.forEach(t => {
        t.columns.forEach(c => {
          if (c.active) {
            list.push({
              key: t.alias + '.' + c.colName,
              name: c.label,
              name1: c.label,
              value: '',
              show: true,
            });
          }
        });
      });
      this.$emit("doneselect", list);
    }
  }
}
</script>

<style scoped lang="scss">
.transfer h4 {
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 10px;
}

.transfer {
  border: 1px solid #d7dae2;
  border-radius: 4px;
  background: #f5f7fa;
}

.transfer .group-name {
  padding-top: 10px;
  padding-bottom: 5px;
  margin: 0px;
}

.group-name {
  border-bottom: 1px solid #dcdfe6;
}

.search-wrap {
  padding: 0px 15px 10px;
  border-bottom: 1px solid #d7dae2;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}

.col-item {
  display: block;
  color: #606266;
  text-decoration: none;
  padding: 3px 10px;
  cursor: pointer;
}

.col-item:hover, .col-item.active {
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
}

.vlist {
  background: white;
}

.vlist .el-scrollbar__wrap {
  overflow-x: hidden;
}

.selected-filter > > > .el-radio-group > label {
  margin-top: 6px;
  margin-bottom: 6px;
}

.pts-checkbox {
  margin: 5px 15px 5px 0px !important;
}
</style>
